import ErrorIcon from '@mui/icons-material/Error';
import { Alert, AlertProps, Link, Typography } from '@mui/material';
import React from 'react';

export interface BannerProps extends AlertProps {
  message: React.ReactNode;
  linkText: string;
  linkUrl: string;
}

export function Banner({
  severity = 'info',
  message,
  linkText,
  linkUrl,
  ...rest
}: BannerProps): React.ReactElement {
  const severityMap: Record<
    NonNullable<AlertProps['severity']>,
    { background: string; icon: string }
  > = {
    error: {
      background: '#FFE2E4',
      icon: '#DE1135',
    },
    warning: {
      background: '#FDF1C8',
      icon: '#EF9A11',
    },
    success: {
      background: '#C7FFE0',
      icon: '#0E8345',
    },
    info: {
      background: '#E8F4FF',
      icon: '#005BB5',
    },
  };

  const { background, icon } = severityMap[severity];

  return (
    <Alert
      icon={<ErrorIcon sx={{ color: icon }} />}
      sx={{
        backgroundColor: background,
        mb: 2,
      }}
      severity={severity}
      {...rest}
    >
      <Typography
        sx={{
          color: '#1A1A1A',
          fontFamily: 'Roboto',
          fontSize: '16px',
        }}
        component="span"
      >
        {message}{' '}
        <Link
          href={linkUrl}
          underline="hover"
          color="inherit"
          variant="body2"
          sx={{
            fontWeight: 'bold',
            textDecoration: 'underline',
            color: '#0076CB',
          }}
        >
          {linkText}
        </Link>
      </Typography>
    </Alert>
  );
}
